import { MESSAGE_TYPES, type DesignerMessage } from "../Types/DesignerMessages";
import { IsDesignMode } from "./runtimeDetection";

let authenticationRequiredSent = false;

export function resolveDesignerOrigin(configuredOrigin?: string): string | undefined {
  if (configuredOrigin && configuredOrigin !== "*") return configuredOrigin;
  if (!document.referrer) return undefined;
  try {
    return new URL(document.referrer).origin;
  } catch {
    return undefined;
  }
}

export function isTrustedDesignerMessage(event: MessageEvent, configuredOrigin?: string): boolean {
  const origin = resolveDesignerOrigin(configuredOrigin);
  return Boolean(origin && event.source === window.parent && event.origin === origin);
}

export function notifyDesignerAuthenticationRequired(
  configuredOrigin: string | undefined,
  reason: "token-unavailable" | "unauthorized"
): void {
  if (!IsDesignMode || authenticationRequiredSent) return;

  const targetOrigin = resolveDesignerOrigin(configuredOrigin);
  if (!targetOrigin) return;

  authenticationRequiredSent = true;
  window.parent.postMessage(
    { type: MESSAGE_TYPES.AUTH_REQUIRED, payload: { reason } } satisfies DesignerMessage,
    targetOrigin
  );
}
